<template>
	<section>
		<div class="bg">
			<div class="title d-block-lt-1024">
				<h1 class="h-text">
					<span>{{ 'Ж/Д доставка\n' }}</span>
					<span>грузов<span class="h-text2"> из Китая</span></span>
				</h1>

				<h2 class="h-subtitle">
					Быстро и безопасно доставим ваш груз от 10 кг, избавив вас
					от лишних забот
				</h2>
			</div>

			<NuxtImg
				alt="Ж/Д доставка"
				src="/images/containers.png"
				class="img"
				format="webp"
				sizes="sm:334px md:500px lg:1060px"
			/>
		</div>

		<div class="col2">
			<div class="title d-block-gte-1024">
				<h1 class="h-text">
					<span>{{ 'Ж/Д доставка\n' }}</span>
					<span>грузов<span class="h-text2"> из Китая</span></span>
				</h1>

				<h2 class="h-subtitle">
					Быстро и безопасно доставим ваш груз от 10 кг, избавив вас
					от лишних забот
				</h2>
			</div>

			<div class="buttons">
				<UIShLink class="calc-link" to="/#calculator">
					<span class="text">{{ TEXT.calc_link }}</span>
					<UIShIcon name="calc" />
					<span class="currency">₽</span>
				</UIShLink>

				<UIShTextSlider :list="SLIDES_TEXT" class="text-slider" />
			</div>
		</div>
	</section>
</template>

<script setup lang="ts">
import { SLIDES_TEXT, TEXT } from '@/common/constants';
</script>

<style lang="scss" scoped>
.bg {
	overflow: hidden;
	position: relative;
	border-radius: var(--border-radius);
	background-color: var(--color-gray900);

	&::before {
		content: '';
		width: 90.7%;
		height: 71.4%;
		background-color: var(--color-gray800);
		position: absolute;
		top: 30.28%;
		left: -11.67%;
		transform: rotate(-30.58deg);
		z-index: var(--z-index-intro-s-rect);
	}
}

.title,
.img {
	position: relative;
	z-index: var(--z-index-intro-s);
}

.title {
	padding: 0.8889rem;

	.h-text {
		@include useFont(dsmb);
		color: var(--color-white);
		text-transform: uppercase;
		white-space: pre-line;
	}

	.h-text2 {
		color: var(--color-gray300);
	}

	.h-subtitle {
		max-width: 13.5556rem;
		margin-top: 0.4444rem;
		@include useFont(tmdm);
		color: var(--color-white);
	}
}

.img {
	display: block;
	height: 14.2778rem;
	border-radius: 1.333rem;
	object-fit: contain;
	object-position: bottom;
}

.col2 {
	margin-top: 0.6667rem;

	.calc-link {
		position: relative;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		padding: 0.8889rem;
		border-radius: 1.1111rem;
		color: var(--color-white);
		background-color: var(--color-brand500);
		@include useFixedSize(100%, 8.2222rem);

		--icon-width: 1.556rem;
		--icon-height: 1.556rem;

		.text {
			@include useFont(txlb);
			text-transform: uppercase;
			white-space: pre-line;
		}

		.currency {
			position: absolute;
			right: -0.944rem;
			bottom: -3.2rem;
			line-height: 13.889rem;
			font-size: 11rem;
			font-weight: 700;
			color: var(--color-white10);
		}

		&:hover {
			background-color: var(--color-brand600);
		}
	}

	.text-slider {
		margin-top: 0.6667rem;
		width: 100%;
		height: 7.7778rem;
	}
}

@include screen768 {
	.bg {
		&::before {
			width: 50.7%;
			height: 71.4%;
		}
	}

	.img {
		height: 24.2778rem;
	}

	.col2 .buttons {
		display: grid;
		grid-template-columns: 1fr 1fr;
		column-gap: 1.111rem;

		.calc-link {
			height: 100%;
			max-height: 100%;
			order: 2;
		}

		.text-slider {
			margin-top: 0;
			width: 100%;
			height: 100%;
		}
	}
}

@include screen1024 {
	section {
		overflow: hidden;
		position: relative;
		display: grid;
		grid-template-columns: 1fr 1fr;
		// grid-template-columns: 57.6% 1fr;
		border-radius: var(--border-radius);
		background-color: var(--color-gray900);

		&::before {
			content: '';
			width: 50.7%;
			height: 71.4%;
			background-color: var(--color-gray800);
			position: absolute;
			top: 30.28%;
			left: -11.67%;
			transform: rotate(-30.58deg);
			z-index: var(--z-index-intro-s-rect);
		}
	}

	.bg {
		display: flex;
		background-color: transparent;

		&::before {
			display: none;
		}
	}

	.img {
		height: unset;
	}

	.col2 {
		margin-top: 0;
		padding: 1.333rem;
		display: flex;
		flex-direction: column;
		justify-content: space-between;

		.title {
			padding: 0;
			margin-top: 5.556rem;
		}

		.buttons {
			margin-top: 1.667rem;
		}
	}
}

@include screen1440 {
	section {
		&::before {
			width: 55%;
			height: 110%;
		}
	}
}

@include screen1920 {
	section {
		grid-template-columns: 57.6% 1fr;
	}

	.col2 {
		padding-right: 2.667rem;
		padding-bottom: 2.667rem;
		padding-left: 1.111rem;
		gap: 6.778rem;

		.buttons {
			display: grid;
			grid-template-columns: 1fr 1fr;
			column-gap: 0.889rem;
			grid-template-rows: 13rem;
			margin-top: 0;
		}

		.calc-link {
			.currency {
				bottom: -1.667rem;
				font-size: 15.056rem;
			}
		}

		.text-slider {
			margin-top: 0.6667rem;
			height: 7.7778rem;
		}
	}

	.title {
		.h-text {
			@include useFont(d2xlb);
		}

		.h-text2 {
			color: var(--color-gray300);
		}

		.h-subtitle {
			max-width: 20.111rem;
			margin-top: 1.111rem;
			@include useFont(dxsm);
		}
	}
}
</style>
